import { Seller } from '../../entities/Seller'
import { httpClient } from '../http/httpClient'
import { UserRoleEnum } from '../usersService/user'

export interface SellerResponse {
  users: Seller[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
    order: string
  }
}

export interface SellerParams {
  role?: UserRoleEnum
  sellerIds?: string
  teamIds?: string
  search?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function seller(params?: SellerParams | undefined) {
  const { data } = await httpClient.get<SellerResponse>('/user', {
    params,
  })

  return data
}
